import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core'
import { GenericLinkModule, IconModule, LinkModule } from '@spartacus/storefront'
import { UserProfileModule } from '@spartacus/user'
import { EbAuthGuard } from '../../../auth/guards/eb-auth.guard'
import { EbFormModule } from '../../../form/eb-form.module'
import { EbCommonFormModule } from '../../../support/common/eb-common-form.module'
import { EbUpdateProfileFormComponent } from './components/update-profile-form/eb-update-profile-form.component'
import { EbUpdateProfileFormConfigService } from './services/facades/eb-update-profile-form-config.service'

@NgModule({
  imports: [
    EbFormModule,
    ReactiveFormsModule,
    CommonModule,
    IconModule,
    I18nModule,
    UserProfileModule,
    GenericLinkModule,
    EbCommonFormModule,
    LinkModule,
    UrlModule,
    RouterModule
  ],
  exports: [EbUpdateProfileFormComponent],
  declarations: [EbUpdateProfileFormComponent],
  providers: [
    EbUpdateProfileFormConfigService,
    provideConfig({
      cmsComponents: {
        UserDetailsComponent: {
          component: EbUpdateProfileFormComponent,
          guards: [EbAuthGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class EbUpdateProfileFormModule {}
